module.exports = __webpack_public_path__ + "img/icon12.f77836d.png";